import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  ModalController,
} from '@ionic/angular/standalone';
import {
  getHorlogeTotalTime,
  SaltHorlogeModel,
  transformSaltBufferToModel,
  transformSaltModelToBuffer,
  VSHorlogeModel,
} from '../../../../../helper/horloge';
import { convertMinutesToTime } from '../../../../../helper/convertSecondsToTime';
import Moment from 'moment/moment';
import moment from 'moment/moment';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TranslatePipe } from '@ngx-translate/core';
import { P00037ConsigneManuel } from '../../Enum/P00037ConsigneManuel';

@Component({
  selector: 'app-function-parameters-setting-clock-week-salt-screen',
  templateUrl:
    './function-parameters-setting-clock-week-salt-screen.component.html',
  styleUrls: [
    './function-parameters-setting-clock-week-salt-screen.component.scss',
  ],
  standalone: true,
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    IonFooter,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
    NgCircleProgressModule,
    TranslatePipe,
  ],
})
export class FunctionParametersSettingClockWeekSaltScreenComponent
  implements OnInit
{
  private modalController = inject(ModalController);

  @Input() value: string = '';
  public valueResult: string = '';

  public horlogesModel: any = [];
  public selectModel: SaltHorlogeModel | null = null;
  public selectModelStep: number = 0;

  isModalOpen = false;

  constructor() {}

  public list: any = [];
  public minuteInterval: number = 60;

  ngOnInit() {
    for (let i = 0; i < 60 * 24; i = i + this.minuteInterval) {
      this.list.push({ label: convertMinutesToTime(i), ref: i * 60 });
    }

    this.valueResult = this.value;
    this.horlogesModel = transformSaltBufferToModel(this.valueResult);
  }

  onCloseSelectTimeIntervalChoice(
    ref: number,
    startDate: number,
    endDate: number,
    consigne: number,
  ) {
    this.isModalOpen = false;

    if (ref == -1) {
      this.horlogesModel.push({
        ref: this.horlogesModel.length + 1,
        start: startDate,
        end: endDate,
        consigne: consigne,
      });
    } else {
      for (let i = 0; i < this.horlogesModel.length; i++) {
        if (this.horlogesModel[i].ref == ref) {
          this.horlogesModel[i].start = startDate;
          this.horlogesModel[i].end = endDate;
          this.horlogesModel[i].consigne = consigne;
        }
      }
    }

    const buf = transformSaltModelToBuffer(this.horlogesModel);
    this.valueResult = buf;
    this.horlogesModel = transformSaltBufferToModel(buf);
  }

  secondeToHourMinute(time: number) {
    let h = Math.floor(time / (60 * 60));
    let m = Math.floor((time - h * 3600) / 60);

    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
  }

  tempsTotal() {
    const time = getHorlogeTotalTime(this.horlogesModel);
    return this.secondeToHourMinute(time);
  }

  onCloseSelectTimeIntervalRemove(ref: number) {
    for (let i = 0; i < this.horlogesModel.length; i++) {
      if (this.horlogesModel[i].ref == ref) {
        this.horlogesModel.splice(i, 1);

        const buf = transformSaltModelToBuffer(this.horlogesModel);
        this.valueResult = buf;
        this.horlogesModel = transformSaltBufferToModel(buf);
        break;
      }
    }

    this.isModalOpen = false;
  }

  transformNumberToDegree(num: number) {
    return (num * 360) / (60 * 60 * 24);
  }

  getLeftPos(num: number) {
    return (num * 100) / (3600 * 24);
  }

  getSize(num: number) {
    return (num / (3600 * 24)) * 100;
  }

  selectConsigne(value: number) {
    this.selectModel!.consigne = value;
  }

  nextStep() {
    this.selectModelStep = this.selectModelStep + 1;
  }

  goToStep(step: number) {
    this.selectModelStep = step;
  }

  selectStart(value: number) {
    this.selectModel!.start = value;
  }

  selectEnd(value: number) {
    this.selectModel!.end = value;
  }

  openModal(selectModel: VSHorlogeModel | null = null) {
    if (selectModel == null) {
      let hourStr = Moment().format('HH');
      this.selectModelStep = 0;
      this.selectModel = {
        ref: -1,
        start: parseInt(hourStr) * 3600,
        end: ((parseInt(hourStr) + 1) % 24) * 3600,
        consigne: 30,
      };
    } else {
      this.selectModel = JSON.parse(JSON.stringify(selectModel));
      this.selectModelStep = 3;
    }

    console.log(this.selectModel);
    this.isModalOpen = true;
  }

  deleteModel() {
    this.onCloseSelectTimeIntervalRemove(this.selectModel!.ref);
  }

  saveModel() {
    this.onCloseSelectTimeIntervalChoice(
      this.selectModel!.ref,
      this.selectModel!.start,
      this.selectModel!.end,
      this.selectModel!.consigne,
    );
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectModel = null;
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss({ value: this.valueResult });
  }

  getStartDate() {
    return moment.utc(this.selectModel!.start! * 1000).format('HH:mm');
  }
  getEndDate() {
    return moment.utc(this.selectModel!.end! * 1000).format('HH:mm');
  }

  protected readonly P00037ConsigneManuel = P00037ConsigneManuel;
}
